const FuturaIcon = ({ className = "w-5 h-5" }) => (
  <svg viewBox="100 50 312 430" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M256 80c-66.3 0-120 53.7-120 120 0 44.2 23.8 82.8 59.3 103.7 7.5 4.4 12.7 12 12.7 20.8V360c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-35.5c0-8.8 5.2-16.4 12.7-20.8C352.2 282.8 376 244.2 376 200c0-66.3-53.7-120-120-120z" stroke="currentColor" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="208" y1="396" x2="304" y2="396" stroke="currentColor" strokeWidth="18" strokeLinecap="round"/>
    <line x1="220" y1="426" x2="292" y2="426" stroke="currentColor" strokeWidth="18" strokeLinecap="round"/>
    <line x1="240" y1="456" x2="272" y2="456" stroke="currentColor" strokeWidth="18" strokeLinecap="round"/>
    <path d="M232 178c0-18 14-32 32-32s32 14 32 32c0 16-12 24-22 30-6 4-10 10-10 16" stroke="currentColor" strokeWidth="16" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="256" cy="254" r="9" fill="currentColor"/>
  </svg>
);

export default FuturaIcon;
